import {
    DMARC_NONE,
    DMARC_QUARANTINE,
    DMARC_STATUS_NO_RECORD,
    DMARC_STATUS_POLICY_INVALID,
    DMARC_STATUS_POLICY_NONE,
    DMARC_STATUS_POLICY_QUARANTINE,
    DMARC_STATUS_POLICY_REJECT,
    DMARC_REJECT,
} from '../../common/constants/dmarc-policy-values';

import {
    dmarcPolicyFilterRenderer,
    dmarcSubdomainPolicyFilterRenderer,
    translateStringRenderer,
} from '../table-utils';

export const domainTypeFilterParams = {
    cellRenderer: translateStringRenderer,
    clearButton: true,
    newRowsAction: 'keep',
    suppressMiniFilter: true,
    values: [ 'sending', 'nonsending' ]
};

export const dmarcPolicyFilterParams = {
    cellRenderer: dmarcPolicyFilterRenderer,
    clearButton: true,
    newRowsAction: 'keep',
    suppressMiniFilter: true,
    values: [
        DMARC_STATUS_POLICY_NONE,
        DMARC_STATUS_POLICY_QUARANTINE,
        DMARC_STATUS_POLICY_REJECT,
        DMARC_STATUS_POLICY_INVALID,
        DMARC_STATUS_NO_RECORD
    ]
};

export const dmarcSubdomainPolicyFilterParams = {
    cellRenderer: dmarcSubdomainPolicyFilterRenderer,
    clearButton: true,
    newRowsAction: 'keep',
    suppressMiniFilter: true,
    values: [ DMARC_NONE, DMARC_QUARANTINE, DMARC_REJECT, null ]
};

export const comparatorFilterParams = {
    clearButton: true,
    greaterThan: 'Greater than',
    lessThan: 'Less than',
};
